// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#faq {
    padding: 2rem;
    padding-bottom: 5rem ;
    background-color: #060606;
  }
  
  .faq-content {
    max-width: 1200px;
    margin: 0 auto;
  }
  
  .section-title {
    font-size: 2.5rem;
    font-weight: 700;
    text-align: center;
    margin-bottom: 2rem;
  }
  
  .faq-accordion {
    display: flex;
    flex-direction: column;
  }
  
  .faq-item {
    margin-bottom: 1rem;
    background-color: #4d4a4a;
    padding: 1rem;
    border-radius: 0.5rem;
    box-shadow: 0px 1px 5px rgba(176, 171, 171, 0.1);
  }
  
  .faq-question {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 1.5rem;
    font-weight: 700;
    color: #ba0f0f;
    cursor: pointer;
  }
  
  .faq-answer {
    font-size: 1.2rem;
    line-height: 1.5;
    margin-top: 1rem;
    color: #dfd9d9;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/css/Faq.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,qBAAqB;IACrB,gDAAgD;EAClD;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;EAChB","sourcesContent":["#faq {\n    padding: 2rem;\n    padding-bottom: 5rem ;\n    background-color: #060606;\n  }\n  \n  .faq-content {\n    max-width: 1200px;\n    margin: 0 auto;\n  }\n  \n  .section-title {\n    font-size: 2.5rem;\n    font-weight: 700;\n    text-align: center;\n    margin-bottom: 2rem;\n  }\n  \n  .faq-accordion {\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .faq-item {\n    margin-bottom: 1rem;\n    background-color: #4d4a4a;\n    padding: 1rem;\n    border-radius: 0.5rem;\n    box-shadow: 0px 1px 5px rgba(176, 171, 171, 0.1);\n  }\n  \n  .faq-question {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 1.5rem;\n    font-weight: 700;\n    color: #ba0f0f;\n    cursor: pointer;\n  }\n  \n  .faq-answer {\n    font-size: 1.2rem;\n    line-height: 1.5;\n    margin-top: 1rem;\n    color: #dfd9d9;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
